@if (!store.isSummary) {
    <ap-previous-button (click)="previousQuestion()"></ap-previous-button>
}

@if (showRenovation()) {
    <renovation></renovation>
}
@if (showRenovationAmount()) {
    <renovation-amount></renovation-amount>
}
@if (showTip()) {
    <renovation-tip></renovation-tip>
}
